module.exports = __webpack_public_path__ + "static/game-rhb-gaemsebruecke-d1d7399b266ed53a2c89a67eb014436f.png";